// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Modal_modal__5\\+qzG {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.3s ease-in-out;
}

.Modal_modalOpen__O0yX6 {
  opacity: 1;
  pointer-events: auto;
}

.Modal_modalBackdrop__bmUfn {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
}

.Modal_modalContent__NhPme {
  background-color: #fff;
  max-height: 80%;
  border-radius: 8px;
  padding: 24px;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
  overflow: auto;
}

@media (max-width: 768px) {
  .Modal_modalContent__NhPme {
    max-width: 100%;
    max-height: 100%;
    border-radius: 0;
  }
}

.Modal_modalContentTasks__k5o7G {
  border-radius: 0px;
  padding: 0px;
}
`, "",{"version":3,"sources":["webpack://./src/components/Modals/Modal.module.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;EACV,oBAAoB;EACpB,oCAAoC;AACtC;;AAEA;EACE,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,oCAAoC;AACtC;;AAEA;EACE,sBAAsB;EACtB,eAAe;EACf,kBAAkB;EAClB,aAAa;EACb,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,wCAAwC;EACxC,cAAc;AAChB;;AAEA;EACE;IACE,eAAe;IACf,gBAAgB;IAChB,gBAAgB;EAClB;AACF;;AAEA;EACE,kBAAkB;EAClB,YAAY;AACd","sourcesContent":[".modal {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 1000;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  opacity: 0;\n  pointer-events: none;\n  transition: opacity 0.3s ease-in-out;\n}\n\n.modalOpen {\n  opacity: 1;\n  pointer-events: auto;\n}\n\n.modalBackdrop {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.5);\n}\n\n.modalContent {\n  background-color: #fff;\n  max-height: 80%;\n  border-radius: 8px;\n  padding: 24px;\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);\n  overflow: auto;\n}\n\n@media (max-width: 768px) {\n  .modalContent {\n    max-width: 100%;\n    max-height: 100%;\n    border-radius: 0;\n  }\n}\n\n.modalContentTasks {\n  border-radius: 0px;\n  padding: 0px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modal": `Modal_modal__5+qzG`,
	"modalOpen": `Modal_modalOpen__O0yX6`,
	"modalBackdrop": `Modal_modalBackdrop__bmUfn`,
	"modalContent": `Modal_modalContent__NhPme`,
	"modalContentTasks": `Modal_modalContentTasks__k5o7G`
};
export default ___CSS_LOADER_EXPORT___;
